module.exports = __webpack_public_path__ + "static/media/eduPink.0266f3fe.svg";